import i18next from 'i18next';

i18next.addResources('es', 'searchBar', {
  placeholder: '¿Qué estás buscando?'
});

i18next.addResources('en', 'searchBar', {
  placeholder: 'What are you looking for?'
});

i18next.addResources('pt', 'searchBar', {
  placeholder: 'O que você está procurando?'
});
